<div class="table-responsive">
  <div class="card">
    <div class="card-body">
      @if (!showProjectsView) {
        <div>
          <div class="project-toolbar">
            <!-- Title -->
            <div style="display: flex;">
              <h3>Projects </h3>
            </div>
            <div class="toolbar-right">
              <div style="float: right;height:50px;">
                <p-tabView (onChange)="handleTableTabChange($event)">
                  <p-tabPanel header="Default">
                  </p-tabPanel>
                  <p-tabPanel header="Custom">
                  </p-tabPanel>
                </p-tabView>
              </div>
              <button
                [style.visibility]="activeTab === 'user' ? 'visible' : 'hidden'"
                class="btn btn-link p-0 mr-2"
                (click)="viewGridSettings()"
                pTooltip="Customize Grid" appActionTooltip style="cursor: pointer;">
                <i class="mdi mdi-cog fs-5 text-primary"></i>
              </button>
              <!-- My Projects -->
              @if (!tkdashboard && !lpcdashboard) {
                <div class="toolbar-item">
                  <select class="form-status-select" [(ngModel)]="selectedFilterOption"
                    (change)="loadProjectsData(lastTableLazyLoadEvent, null, null, dt)" [attr.title]="'My Projects'">
                    @for (filter of filterOptions; track filter) {
                      <option [ngValue]="filter.value">
                        {{ filter.label }}
                      </option>
                    }
                  </select>
                </div>
              }
              <!-- Search -->
              <div class="toolbar-item search-box">
                <div class="search-container">
                  <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchTerm"
                    (keyup.enter)="loadProjectsData(lastTableLazyLoadEvent)">
                  <button class="search-button" (click)="loadProjectsData(lastTableLazyLoadEvent)"
                    pTooltip="Search" appActionTooltip>
                    <img src="assets/images/search.png" alt="Search">
                  </button>
                  <button class="search-button sb-close" pTooltip="Clear search" appActionTooltip
                    (click)="searchTerm=''; loadProjectsData(lastTableLazyLoadEvent)">
                    <i class="mdi mdi-window-close"></i>
                  </button>
                </div>
              </div>
              <!-- Refresh -->
              <div class="toolbar-item">
                <button class="btn btn-primary btn-sm" (click)="loadProjectsData(lastTableLazyLoadEvent)"
                  pTooltip="Refresh Table" appActionTooltip>
                  <i class="mdi mdi-reload"></i>
                </button>
              </div>
              <!-- Clear Filters -->
              <div class="toolbar-item">
                @if (!widgetFilters || widgetFilters?.length==0) {
                  <button class="btn btn-primary btn-sm m-1"  (click)="clearAllFilters(dt)" pTooltip="Clear Filters" appActionTooltip>Clear<i
                  class="mdi mdi-filter-remove"></i></button>
                }
                @if (widgetFilters && widgetFilters.length>0 && filterSource === 'widget') {
                  <button class="btn btn-danger btn-sm m-1" (click)="clearWidgetsFilter()" pTooltip="Clear Widgets Filters" appActionTooltip>Clear Widgets Filters<i
                  class="mdi mdi-filter-remove"></i></button>
                }
                @if (widgetFilters && widgetFilters.length>0 && filterSource === 'entity') {
                  <button class="btn btn-danger btn-sm m-1" (click)="clearWidgetsFilter()" pTooltip="Clear Entity Filters" appActionTooltip>Clear Entity Filters<i
                  class="mdi mdi-filter-remove"></i></button>
                }
                @if (widgetFilters && widgetFilters.length>0 && filterSource === 'CONTACTS_GRID') {
                  <button class="btn btn-danger btn-sm m-1" (click)="clearWidgetsFilter()" pTooltip="Clear Contacts Filters" appActionTooltip>Clear Contacts Filters<i
                  class="mdi mdi-filter-remove"></i></button>
                }
              </div>
              <!-- Export -->
              @if (authService.roles?.includes('ADMIN') || authService.roles?.includes('Reporting')) {
                <div class="toolbar-item"
                  >
                  <span appActionTooltip [pTooltip]="btnLoading ? getExportDisabledReason() : 'Export projects to Excel'"
                    [actionDisabled]="btnLoading">
                    <button class="btn btn-success btn-sm" (click)="exportProjects()" [disabled]="btnLoading">
                      @if (!btnLoading) {
                        <span>
                          <i class="mdi mdi-file-excel"></i> Export
                        </span>
                      }
                      @if (btnLoading) {
                        <span>
                          <i class="mdi mdi-loading mdi-spin"></i> Exporting...
                        </span>
                      }
                    </button>
                  </span>
                </div>
              }
              <!-- Add Project -->
              @if (!disableEdit) {
                <div class="toolbar-item">
                  <button class="btn btn-success btn-sm" (click)="addProject()"
                    pTooltip="Add Project" appActionTooltip>
                    <i class="mdi mdi-plus"></i>
                    Add Project
                  </button>
                </div>
              }
            </div>
          </div>
          @if (gridLoadError) {
            <div class="alert alert-danger mb-2" role="alert">{{ gridLoadError }}</div>
          }
          <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadProjectsData($event)" [value]="projects"
            dataKey="id" styleClass="p-datatable-projects" [rowHover]="true" [rows]="10"
            [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
            responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0"
            paginatorDropdownAppendTo="body">
            <ng-template pTemplate="header" let-columns let-value="projects">
              <tr>
                <th style="width:1%; white-space:nowrap; text-align:center; vertical-align:middle;">Actions</th>
                <th pSortableColumn="name">
                  <div class="flex justify-content-between align-items-center">
                    Project Name
                    <p-sortIcon field="name"></p-sortIcon>
                    <p-columnFilter [showOperator]="false" [showAddButton]="false"
                      [matchModeOptions]="matchModeOptions" type="text" matchMode="contains"
                    field="name" display="menu"></p-columnFilter>
                  </div>
                </th>
                <th pSortableColumn="id">
                  <div class="flex justify-content-between align-items-center">
                    Project Id
                    <p-sortIcon field="id"></p-sortIcon>
                    <p-columnFilter [showOperator]="false" [showAddButton]="false"
                      [matchModeOptions]="matchModeOptionsNumber" type="numeric" [useGrouping]="false"  field="id"
                    display="menu"></p-columnFilter>
                  </div>
                </th>
                @for (col of cols; track col) {
                  @if (col.visible) {
                    <th  [pSortableColumn]="col.disableActions ? null : col.field">
                      <div class="flex justify-content-between align-items-center">
                        {{ col.header }}
                        @if (!col.disableActions) {
                          <p-sortIcon [field]="col.field"></p-sortIcon>
                        }
                        @if (!col.disableActions) {
                          @switch (col.field) {
                            @case (['startDate', 'closedDate', 'dueDate'].includes(col.field) ? col.field : '') {
                              <p-columnFilter
                                [field]="col.field" type="date" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false" [showClearButton]="false" [showApplyButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                  <p-dropdown [options]="matchModeOptionsDate"
                                    [(ngModel)]="filterDatesMatchModes[col.field]"
                                  (onChange)="onDateFilterChange(col.field)"></p-dropdown>
                                  <p-calendar [(ngModel)]="filterDates[col.field]"
                                    [selectionMode]="filterDatesMatchModes[col.field] === 'betweenDate' ? 'range' : 'single'"
                                  [readonlyInput]="true"></p-calendar>
                                  <div class="flex items-center" style="float:right">
                                    <button type="button" class="btn btn-primary" (click)="applyDatesFilter(col.field)" pTooltip="Apply date filter" appActionTooltip>Apply</button>
                                    <button type="button" class="btn btn-danger" (click)="clearDatesFilter(col.field)" pTooltip="Clear date filter" appActionTooltip>Clear</button>
                                  </div>
                                </ng-template>
                              </p-columnFilter>
                            }
                            @case (['submitToBilling', 'isPreInvoiced', 'isInvoicePaid', 'isBillable', 'holdTimeUntilCompleted'].includes(col.field) ? col.field : '') {
                              <p-columnFilter
                                [field]="col.field" matchMode="equals" display="menu" [showOperator]="false" [showAddButton]="false" [showClearButton]="true" [showApplyButton]="true" [showMatchModes]="false" >
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                  <p-dropdown [ngModel]="value" [options]="isBillableList" (onChange)="filter($event.value)" placeholder="Any">
                                    <ng-template let-option pTemplate="item">
                                      <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                                    </ng-template>
                                  </p-dropdown>
                                </ng-template>
                              </p-columnFilter>
                            }
                            @case (['projectTypeCode', 'statusCode'].includes(col.field) ? col.field : '') {
                              <p-columnFilter
                                [field]="col.field" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showClearButton]="true" [showApplyButton]="true">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                  <p-multiSelect [maxSelectedLabels]="10000" [ngModel]="value"
                                    [options]="col.field === 'statusCode' ? statuses : projectTypeCodes"
                                    (onChange)="filter($event.value)" optionLabel="label" placeholder="Any">
                                  </p-multiSelect>
                                </ng-template>
                              </p-columnFilter>
                            }
                            @case ('serviceType') {
                              <p-columnFilter
                                [field]="col.field" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" [showClearButton]="true" [showApplyButton]="true">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                  <p-multiSelect [maxSelectedLabels]="10000" [ngModel]="value"
                                    [options]="serviceTypes"
                                    (onChange)="filter($event.value)" optionLabel="label" placeholder="Any">
                                  </p-multiSelect>
                                </ng-template>
                              </p-columnFilter>
                            }
                            @case (['id', 'estimatedBudget'].includes(col.field) ? col.field : '') {
                              <p-columnFilter
                                type="numeric" [field]="col.field" display="menu" [useGrouping]="false"
                                [showOperator]="false" [showAddButton]="false">
                              </p-columnFilter>
                            }
                            @default {
                              <p-columnFilter
                                type="text" [field]="col.field" display="menu" matchMode="contains"
                                [showOperator]="false" [showAddButton]="false">
                              </p-columnFilter>
                            }
                          }
                        }
                      </div>
                    </th>
                  }
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-projects let-columns="columns">
              <tr class="project-row" (click)="clicked(projects)">
                <td>
                  <div class="flex align-items-center gap-3" (click)="$event.stopPropagation()">
                                    <div class="notification-wrapper" [ngClass]="{
                                                                        'has-notifications': projects.unreadReminderNotificationCount > 0,
                                                                        'no-notifications': projects.unreadReminderNotificationCount === 0
                                                                    }"
                      (click)="projects.unreadReminderNotificationCount > 0 && openReminderNotificationDialog(projects)"
                      [pTooltip]="projects.unreadReminderNotificationCount > 0 ? 'View Reminder Notifications for this Project' : 'No Reminder Notifications'" appActionTooltip>
                      <i class="mdi mdi-bell-outline notification-icon"></i>
                      @if (projects.unreadReminderNotificationCount > 0) {
                        <span class="notification-badge">
                          {{ projects.unreadReminderNotificationCount }}
                        </span>
                      }
                    </div>
                    <span appActionTooltip
                      [pTooltip]="projects.disableManageReminders ? projects.disableManageRemindersTitle : 'Manage Reminders for this Project'"
                      [actionDisabled]="projects.disableManageReminders">
                      <button role="button" class="btn btn-danger btn-sm"
                        [disabled]="projects.disableManageReminders"
                        (click)="openReminderDialog(projects)">
                        <i class="mdi mdi-bell-plus"></i>
                      </button>
                    </span>
                    <button class="btn btn-info btn-sm" (click)="clicked(projects)" [pTooltip]="projects.viewProjectTitle || 'View Project Details'" appActionTooltip>
                      <i class="mdi mdi-eye"></i>
                    </button>
                    @if (!disableEdit) {
                      <span appActionTooltip
                        [pTooltip]="projects.disableEditProject ? projects.disableEditProjectTitle : 'Edit Project Details'"
                        [actionDisabled]="projects.disableEditProject">
                        <button class="btn btn-warning btn-sm"
                          [disabled]="projects.disableEditProject" (click)="editProject(projects)">
                          <i class="mdi mdi-pencil"></i>
                        </button>
                      </span>
                    }
                    @if (!disableEdit) {
                      <span appActionTooltip
                        [pTooltip]="projects.disableAssignProject ? projects.disableAssignProjectTitle : 'Create New Task for this Project'"
                        [actionDisabled]="projects.disableAssignProject">
                        <button class="btn btn-warning btn-sm"
                          [disabled]="projects.disableAssignProject" (click)="openAssignTask(projects)">
                          <i class="mdi mdi-account-plus"></i>
                        </button>
                      </span>
                    }
                    @if (!disableEdit) {
                      <span appActionTooltip
                        [pTooltip]="!projects.submitToBillingEnabled ? projects.submitToBillingTitle : 'Submit Project To Billing'"
                        [actionDisabled]="!projects.submitToBillingEnabled">
                        <button class="btn btn-success btn-sm"
                          [disabled]="!projects.submitToBillingEnabled" (click)="submitToBilling(projects)">
                          <i class="mdi mdi-send"></i>
                        </button>
                      </span>
                    }
                  </div>
                </td>
                <td>
                  @if (authService?.roles.includes('LPC') || authService?.roles.includes('ADMIN')) {
                    <span
                      >
                      <a href="javascript:void(0);" pTooltip="View Project Details" appActionTooltip
                        (click)="$event.preventDefault()">
                      {{projects['name']}}</a>
                    </span>
                  }
                  @if (!authService?.roles.includes('LPC') && !authService?.roles.includes('ADMIN')) {
                    <span
                      >
                      {{projects['name']}}
                    </span>
                  }
                </td>
                <td>
                  {{projects['id']}}
                </td>
                @for (col of columns; track col) {
                  @if (col.visible) {
                    <td  >
                      <div class="wrap-col-text">
                        @switch (col.field) {
                          @case ('estimatedTime') {
                            {{ projects[col.field] | minutesToTime }}
                          }
                          @case ('actualTime') {
                            {{ projects[col.field] | minutesToTime }}
                          }
                          @case ('isInvoicePaid') {
                            {{ projects[col.field] ? 'Yes' : 'No' }}
                          }
                          @default {
                            {{ projects[col.field] }}
                          }
                        }
                        <!-- <ng-container *ngIf="col.showHistoryIcon==true">
                        <span class="history-icon" [attr.title]=" projects.dueDateChangeCount > 0 ? 'Click to view Audit History' : 'No Audit History Available'">
                          <i
                            class="mdi mdi-history"
                                            [ngStyle]="{
                                                color: projects.dueDateChangeCount > 0 ? 'var(--al-success)' : 'var(--al-danger)',
                                                opacity: projects.dueDateChangeCount > 0 ? 1 : 0.5,
                                                cursor: projects.dueDateChangeCount > 0 ? 'pointer' : 'not-allowed'
                                            }"
                            [class.disabled]="projects.dueDateChangeCount === 0"
                            (click)="projects.dueDateChangeCount > 0 && showAuditData(projects.id, col.field, col.header)"
                            tabindex="0"
                          ></i>
                        </span>
                      </ng-container> -->
                      @if (col.showHistoryIcon == true) {
                        <ng-container
                        *ngTemplateOutlet="historyTemplate; context: { count: getAuditCount(col.field, projects) }"></ng-container>
                      }
                      <ng-template #historyTemplate let-count="count">
                        <span class="history-icon" [pTooltip]="count > 0 ? 'Click to view Audit History' : 'No Audit History Available'"
                          appActionTooltip (click)="$event.stopPropagation()">
                                                <i class="mdi mdi-history" [ngStyle]="{
                                                  'color': count > 0 ? 'var(--al-success)' : 'var(--al-danger)',
                                                  'opacity': count > 0 ? 1 : 0.5,
                                                  'cursor': count > 0 ? 'pointer' : 'not-allowed'
                                               }" [class.disabled]="count === 0" (click)="count > 0 && showAuditData(projects.id, col.field, col.header)"
                            tabindex="0">
                          </i>
                        </span>
                      </ng-template>
                    </div>
                  </td>
                }
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns && columns.length">
                No records found
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
    @if (showProjectsView) {
      <div class="project-workspace">
        <header class="pd-head">
          <button type="button" class="pw-back" (click)="exitProjectWorkspace()"
            pTooltip="Back to the projects grid" appActionTooltip>
            <i class="mdi mdi-arrow-left"></i>Back to projects
          </button>
          <div class="pd-titlerow">
            <h2 class="pd-title">{{ selectedProject?.name }}</h2>
            @if (selectedProject?.id) {
              <button type="button" class="pw-id" (click)="copyProjectId()"
                [attr.aria-label]="'Copy project ID ' + selectedProject.id"
                [class.is-failed]="projectIdCopyState === 'failed'"
                [pTooltip]="projectIdCopyState === 'failed' ? 'Copy failed. Select the ID and copy it manually' : 'Copy project ID'" appActionTooltip>
                {{ projectIdCopyState === 'copied' ? 'Copied!' : '#' + selectedProject.id }}
                @if (projectIdCopyState !== 'copied') {
                  <i class="mdi" [class.mdi-content-copy]="!projectIdCopyState"
                    [class.mdi-alert-circle-outline]="projectIdCopyState === 'failed'"></i>
                }
              </button>
              <span class="visually-hidden" aria-live="polite">{{ projectIdCopyState === 'copied' ? 'Project ID copied' : projectIdCopyState === 'failed' ? 'Could not copy project ID' : '' }}</span>
            }
            @if (selectedProject?.statusCode) {
              <span class="project-status">{{ selectedProject.statusCode }}</span>
            }
            <div class="pd-actions">
              <span appActionTooltip
                [pTooltip]="selectedProject?.disableManageReminders ? selectedProject?.disableManageRemindersTitle : 'Manage Reminders for this Project'"
                [actionDisabled]="selectedProject?.disableManageReminders">
                <button class="btn btn-light btn-sm" [disabled]="selectedProject?.disableManageReminders"
                  (click)="openReminderDialog(selectedProject)">Manage reminders</button>
              </span>
              @if (!disableEdit) {
                @if (projectWorkspaceTabIndex === 0) {
                  <span appActionTooltip
                    [pTooltip]="!selectedProject?.submitToBillingEnabled ? selectedProject?.submitToBillingTitle : 'Submit Project To Billing'"
                    [actionDisabled]="!selectedProject?.submitToBillingEnabled">
                    <button class="btn btn-light btn-sm" [disabled]="!selectedProject?.submitToBillingEnabled"
                      (click)="submitToBilling(selectedProject)">Submit to billing</button>
                  </span>
                }
                <span appActionTooltip
                  [pTooltip]="selectedProject?.disableAssignProject ? selectedProject?.disableAssignProjectTitle : 'Create New Task for this Project'"
                  [actionDisabled]="selectedProject?.disableAssignProject">
                  <button class="btn btn-light btn-sm" [disabled]="selectedProject?.disableAssignProject"
                    (click)="openAssignTask(selectedProject)">Create task</button>
                </span>
                <span appActionTooltip
                  [pTooltip]="selectedProject?.disableEditProject ? selectedProject?.disableEditProjectTitle : 'Edit Project Details'"
                  [actionDisabled]="selectedProject?.disableEditProject">
                  <button class="btn btn-primary btn-sm" [disabled]="selectedProject?.disableEditProject"
                    (click)="editProject(selectedProject)">Edit project</button>
                </span>
              }
            </div>
          </div>
          <dl class="pd-meta">
            @if (selectedProject?.organizationName) { <div><dt>Organization Name</dt><dd><a href="javascript:void(0)" class="pd-link" (click)="openProjectOrganization()">{{ selectedProject.organizationName }}</a></dd></div> }
            @if (selectedProject?.matterName) { <div><dt>Matter Name</dt><dd><a href="javascript:void(0)" class="pd-link" (click)="openProjectMatter()">{{ selectedProject.matterName }}</a></dd></div> }
            @if (selectedProject?.projectTypeCode) { <div><dt>Project Type</dt><dd>{{ selectedProject.projectTypeCode }}</dd></div> }
            @if (projectServiceTypeLabel) { <div><dt>Service Type</dt><dd>{{ projectServiceTypeLabel }}</dd></div> }
            @if (selectedProject?.lpcUserEmail) { <div><dt>LPC</dt><dd>{{ selectedProject.lpcUserEmail }}</dd></div> }
          </dl>
        </header>

        @if (selectedProject?.disableEditProject && selectedProject?.disableEditProjectTitle) {
          <div class="pv-lock" role="status">
            <i class="mdi mdi-lock-outline" aria-hidden="true"></i>
            <span><b>This project is read-only for you.</b> {{ selectedProject.disableEditProjectTitle }}</span>
          </div>
        }

        <p-tabView [cache]="false" [(activeIndex)]="projectWorkspaceTabIndex" styleClass="project-workspace-tabs">
            <p-tabPanel>
              <ng-template pTemplate="header">
                <span class="project-tab-label">Details</span>
              </ng-template>
              <div class="pd-main">
                <div class="pd-left">
                  <section class="pd-card pd-summary" aria-label="Budget and billing summary">
                    <div class="pd-fig" [class.is-over]="projectHasEstimate && projectTimeLeft < 0">
                      <div class="pd-fig-top">
                        <span class="pd-label">Actual Time</span>
                        @if (projectHasEstimate) { <span class="pd-pct">{{ projectTimeRatio | number:'1.0-0' }}%</span> }
                      </div>
                      <div class="pd-line">
                        <span class="pd-value">{{ selectedProject?.actualTime | minutesToTime }}</span>
                        @if (projectHasEstimate) { <span class="pd-of">/ {{ selectedProject?.estimatedTime | minutesToTime }}</span> }
                        <span class="pd-foot">
                          @if (!projectHasEstimate) {
                            No estimate
                            @if (projectEnforcementConflict && !disableEdit && !selectedProject?.disableEditProject) {
                              · <a href="javascript:void(0)" (click)="editProject(selectedProject)">Set one</a>
                            }
                          } @else if (projectTimeLeft < 0) {
                            {{ projectTimeLeftAbs | minutesToTime }} over
                          } @else {
                            {{ projectTimeLeftAbs | minutesToTime }} left
                          }
                        </span>
                      </div>
                      @if (projectHasEstimate) {
                        <span class="pd-meter" role="img" [attr.aria-label]="'Time used ' + (projectTimeRatio | number:'1.0-0') + '%'">
                          <i [style.width.%]="projectTimePercent"></i>
                        </span>
                      }
                    </div>
                    <div class="pd-fig" [class.is-over]="isProjectOverBudget">
                      <div class="pd-fig-top">
                        <span class="pd-label">Actual Spend</span>
                        @if (hasProjectViewBudget) { <span class="pd-pct">{{ projectSpendRatio | number:'1.0-0' }}%</span> }
                      </div>
                      <div class="pd-line">
                        <span class="pd-value">{{ selectedProject?.actualSpend || '$0.00' }}</span>
                        @if (hasProjectViewBudget) { <span class="pd-of">/ {{ selectedProject?.estimatedBudget }}</span> }
                        <span class="pd-foot">
                          @if (!hasProjectViewBudget) {
                            No budget
                          } @else if (isProjectOverBudget) {
                            {{ projectBudgetLeftAbs | currency }} over
                          } @else {
                            {{ projectBudgetLeftAbs | currency }} left
                          }
                        </span>
                      </div>
                      <span class="pd-meter" [class.is-empty]="!hasProjectViewBudget" role="img"
                        [attr.aria-label]="hasProjectViewBudget ? 'Budget used ' + (projectSpendRatio | number:'1.0-0') + '%' : 'No budget'">
                        <i [style.width.%]="projectSpendPercent"></i>
                      </span>
                    </div>
                    <div class="pd-fig">
                      <div class="pd-fig-top">
                        <span class="pd-label">Invoice</span>
                        @if (selectedProject?.invoiceNumber) {
                          <button type="button" class="pd-invoice-no" (click)="copyToClipboard('invoice-number', selectedProject.invoiceNumber)"
                            [attr.aria-label]="'Copy invoice number ' + selectedProject.invoiceNumber" pTooltip="Copy invoice number" appActionTooltip>
                            {{ copiedKey === 'invoice-number' ? 'Copied!' : '#' + selectedProject.invoiceNumber }}
                            @if (copiedKey !== 'invoice-number') { <i class="mdi mdi-content-copy" aria-hidden="true"></i> }
                          </button>
                        }
                        @else { <span class="pd-pct pd-pct-none">No invoice number</span> }
                      </div>
                      <ol class="pd-steps" [attr.aria-label]="'Invoice status: ' + projectInvoiceState">
                        @for (step of projectInvoiceSteps; track step.label) {
                          <li [class.is-done]="step.state === 'done'" [class.is-no]="step.state === 'no'">
                            <i class="mdi" [class.mdi-check-circle]="step.state === 'done'" [class.mdi-minus-circle-outline]="step.state === 'no'"
                              [class.mdi-help-circle-outline]="step.state === 'unknown'" aria-hidden="true"></i>
                            <span>{{ step.label }}<span class="visually-hidden">: </span><span class="pd-step-state">{{ step.state === 'done' ? 'Yes' : step.state === 'no' ? 'No' : 'Not recorded' }}</span></span>
                          </li>
                        }
                      </ol>
                    </div>
                  </section>

                  <section class="pd-card pd-clamp" [class.is-open]="showFullProjectDescription">
                    <div class="pd-card-head">
                      <h3>
                        <button type="button" class="pd-collapse" (click)="toggleProjectText()"
                          [attr.aria-expanded]="showFullProjectDescription" aria-controls="pd-text-body">
                          <i class="mdi" [class.mdi-chevron-down]="showFullProjectDescription" [class.mdi-chevron-right]="!showFullProjectDescription" aria-hidden="true"></i>
                          Description &amp; Notes
                        </button>
                      </h3>
                    </div>
                    @if (showFullProjectDescription) {
                      <div id="pd-text-body" class="pd-pair">
                        @for (field of ['description', 'notes']; track field) {
                          @let text = field === 'description' ? selectedProject?.description : selectedProject?.notes;
                          @let isLong = field === 'description' ? projectDescriptionIsLong : projectNotesAreLong;
                          <div class="pd-sub" [class.is-clamped]="isLong">
                            <div class="pd-sub-head">
                              <h4 class="pd-label">{{ field === 'description' ? 'Description' : 'Notes' }}
                                @if (field === 'notes' && selectedProject?.updatedOn) {
                                  <span class="pd-hint">Updated {{ selectedProject.updatedOn | date:'MM/dd/yyyy' }}</span>
                                }
                              </h4>
                              @if (canEditProjectText) {
                                <button type="button" class="pd-icon-btn" (click)="openProjectText($any(field), 'edit')"
                                  [attr.aria-label]="'Edit ' + field" [pTooltip]="'Edit ' + field" appActionTooltip>
                                  <i class="mdi mdi-pencil-outline"></i>
                                </button>
                              }
                            </div>
                            @if (text) {
                              <p class="pd-text pd-clamp-body">{{ text }}</p>
                              @if (isLong) {
                                <button type="button" class="pd-more" (click)="openProjectText($any(field), 'read')">
                                  Show more <i class="mdi mdi-arrow-top-right"></i>
                                </button>
                              }
                            } @else {
                              <p class="pd-text pd-empty">{{ field === 'description' ? 'No description' : 'No notes on this project yet.' }}</p>
                            }
                          </div>
                        }
                      </div>
                    }
                  </section>

                  <section class="pd-card pd-grow">
                    <div class="pd-card-head">
                      <h3>Fields</h3>
                    </div>
                    <div class="pd-fields">
                      <div class="pd-group">
                        <h4 class="pd-label">Project</h4>
                        <dl>
                          @if (selectedProject?.organizationName) { <dt>Organization Name</dt><dd><a href="javascript:void(0)" class="pd-link" (click)="openProjectOrganization()">{{ selectedProject.organizationName }}</a></dd> }
                          @if (selectedProject?.matterName) { <dt>Matter Name</dt><dd><a href="javascript:void(0)" class="pd-link" (click)="openProjectMatter()">{{ selectedProject.matterName }}</a></dd> }
                          @if (selectedProject?.name) { <dt>Project Name</dt><dd>{{ selectedProject.name }}</dd> }
                          @if (selectedProject?.projectTypeCode) { <dt>Project Type</dt><dd>{{ selectedProject.projectTypeCode }}</dd> }
                          @if (projectServiceTypeLabel) { <dt>Service Type</dt><dd>{{ projectServiceTypeLabel }}</dd> }
                          @if (selectedProject?.priorityCode) { <dt>Priority</dt><dd>{{ selectedProject.priorityCode }}</dd> }
                          @if (selectedProject?.projectTemplateName) { <dt>Template Assigned</dt><dd>{{ selectedProject.projectTemplateName }}</dd> }
                        </dl>
                      </div>
                      <div class="pd-group">
                        <h4 class="pd-label">Status, owner &amp; dates</h4>
                        <dl>
                          @if (selectedProject?.statusCode) { <dt>Status</dt><dd>{{ selectedProject.statusCode }}</dd> }
                          @if (selectedProject?.lpcUserEmail) { <dt>LPC</dt><dd>{{ selectedProject.lpcUserEmail }}</dd> }
                          @if (selectedProject?.requestedBy) { <dt>Requested By</dt><dd>{{ selectedProject.requestedBy }}</dd> }
                          @if (selectedProject?.startDate) { <dt>Start Date</dt><dd class="pd-num">{{ selectedProject.startDate | date:'MM/dd/yyyy' }}</dd> }
                          @if (selectedProject?.dueDate) {
                            @let fieldOverdue = dueDateOverdueDays(selectedProject.dueDate, selectedProject.statusCode, selectedProject.closedDate);
                            <dt>Due Date</dt><dd class="pd-num">{{ selectedProject.dueDate | date:'MM/dd/yyyy' }}@if (fieldOverdue) {<span class="pd-overdue">{{ fieldOverdue }} {{ fieldOverdue === 1 ? 'day' : 'days' }} overdue</span>}</dd>
                          }
                          @if (selectedProject?.closedDate) { <dt>Close Date</dt><dd class="pd-num">{{ selectedProject.closedDate | date:'MM/dd/yyyy' }}</dd> }
                        </dl>
                      </div>
                      <div class="pd-group">
                        <h4 class="pd-label">Billing rules</h4>
                        <dl>
                          @if (selectedProject?.isBillable) { <dt>Billable</dt><dd>{{ selectedProject.isBillable }}</dd> }
                          @if (selectedProject?.isBillable) { <dt>Non Billable Reason</dt><dd [class.pd-empty]="isYes(selectedProject.isBillable) || !selectedProject.nonBillableReason">{{ isYes(selectedProject.isBillable) ? 'N/A' : (selectedProject.nonBillableReason || 'Not provided') }}</dd> }
                          @if (selectedProject?.isEnforceEstimatedTime) { <dt>Enforced Estimated Time</dt><dd>{{ selectedProject.isEnforceEstimatedTime }}</dd> }
                          @if (selectedProject?.holdTimeUntilCompleted) { <dt>Hold Time Until Completed</dt><dd>{{ selectedProject.holdTimeUntilCompleted }}</dd> }
                        </dl>
                      </div>
                    </div>
                    <div class="pd-fields pd-fields-foot">
                      <div class="pd-group pd-contacts">
                        <ng-container *ngTemplateOutlet="contactsSummary; context: { $implicit: workspaceContacts, source: 'view' }"></ng-container>
                      </div>
                    </div>
                  </section>
                </div>

                @if (selectedProject?.id) {
                  <aside class="pd-card pd-rail" aria-label="Updates">
                    <div class="pd-card-head">
                      <h3>Updates</h3>
                    </div>
                    <app-comments [targetType]="'Project'" [targetId]="selectedProject.id"></app-comments>
                  </aside>
                }
              </div>
            </p-tabPanel>
            <p-tabPanel>
              <ng-template pTemplate="header">
                <span class="project-tab-label">Tasks</span>
                @if (selectedProject?.projectTaskCount !== null && selectedProject?.projectTaskCount !== undefined) {
                  <span class="project-tab-count">{{ selectedProject.projectTaskCount }}</span>
                }
              </ng-template>
              <app-task-grid [projTasksFilter]="selectedProject?.id" (tasksChanged)="refreshProjectTaskCount()"></app-task-grid>
            </p-tabPanel>
            <p-tabPanel>
              <ng-template pTemplate="header">
                <span class="project-tab-label">Time records</span>
              </ng-template>
              <app-time-record-grid [tasksgridPrjFilter]="selectedProject?.id"></app-time-record-grid>
            </p-tabPanel>
          </p-tabView>
        </div>
      }
    </div>
  </div>
</div>

<!-- Common Project Edit/View Template -->
<ng-template #projectEditTemplate>

  <div class="card-body">
    <app-notification [errorMsg]="errorMsg" [closable]="true"></app-notification>
    @if (faloading) {
      <div class="loader">
        <div class="spinner"></div>
      </div>
    }
    <form [formGroup]="projectForm">
      <div class="al-dialog-body">
      <div class="al-dialog-split" [class.is-collapsed]="!showProjectNotesPanel">
      <div class="al-form-col">
      <div class="mb-1">
        <label for="projectName" class="form-label mb-1">Project Name
          @if (getFieldInfo('name'); as info) {
            @if (info.showInformation === 'Yes' && info.informationText) {
              <info-tooltip [infoText]="info.informationText"></info-tooltip>
            }
          }
        </label><span style="color:var(--al-danger);">*</span>
        <input #projectNameInput class="form-control p-2" type="text" id="projectName" formControlName="name"
          autocomplete="off" appSpellCheck [readonly]="viewOnly">
        @if (submitted && name && name.invalid) {
          <span style="color:var(--al-danger)">Project Name is required</span>
        }
      </div>
      <div class="al-vitals">
        <div class="al-vital">
          <div class="mb-1">
            <label class="form-label">Status
              <span class="history-icon"
                [pTooltip]="projectForm.getRawValue().projectStatusChangeCount > 0 ? 'Click to view Audit History' : 'No Audit History Available'" appActionTooltip>
                <i class="mdi mdi-history" [ngStyle]="{
                      color: projectForm.getRawValue().projectStatusChangeCount > 0 ? 'var(--al-success)' : 'var(--al-danger)',
                      opacity: projectForm.getRawValue().projectStatusChangeCount > 0 ? 1 : 0.5,
                      cursor: projectForm.getRawValue().projectStatusChangeCount > 0 ? 'pointer' : 'not-allowed'
                    }" [class.disabled]="projectForm.getRawValue().projectStatusChangeCount === 0"
                  (click)="projectForm.getRawValue().projectStatusChangeCount > 0 && showAuditData(projectForm.getRawValue().id, 'statusCode', 'Project Status')"
                tabindex="0"></i>
              </span>
              @if (getFieldInfo('statusCode'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <select class="form-select" formControlName="statusCode"
                [attr.aria-describedby]="statusCode?.disabled && getProjectStatusDisabledReason() ? 'projectStatusHelp' : null">
                <option [value]="">Select</option>
                @for (status of statuses; track status) {
                  <option [ngValue]="status.value"
                  [selected]="status.value == projectForm.getRawValue().statusCode">{{status.label}}</option>
                }
                <option value="Submitted to Billing" readonly selected>Submitted to Billing</option>
              </select>
              @if (statusCode?.disabled && getProjectStatusDisabledReason()) {
                <small id="projectStatusHelp" class="al-field-help">{{ getProjectStatusDisabledReason() }}</small>
              }
              @if (submitted && statusCode && statusCode.invalid) {
                <span style="color:var(--al-danger)">Status is required</span>
              }
          </div>
        </div>
        <div class="al-vital">
          <div class="mb-1">
            <label class="form-label">Priority
              @if (getFieldInfo('priorityCode'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <select class="form-select" formControlName="priorityCode">
                <option [value]="">Select</option>
                @for (obj of priorities; track obj) {
                  <option [value]="obj.value"
                  [selected]="obj.value == projectForm.getRawValue().priorityCode">{{obj.label}}</option>
                }
              </select>
              @if (submitted && priorityCode && priorityCode.invalid) {
                <span style="color:var(--al-danger)">Priority is required</span>
              }
          </div>
        </div>
        <div class="al-vital">
          <div class="mb-1">
            <label for="serviceType" class="form-label">Service Type
              <info-tooltip
              infoText="Whether this project is ongoing managed work or a one-off transactional matter."></info-tooltip>
            </label>
            <select class="form-select" id="serviceType" formControlName="serviceType">
              @for (obj of serviceTypes; track obj) {
                <option [value]="obj.value"
                [selected]="obj.value == projectForm.getRawValue().serviceType">{{obj.label}}</option>
              }
            </select>
          </div>
        </div>
        <div class="al-vital-pair">
        <div class="al-vital">
          <div class="mb-1">
            <label for="startDate" class="form-label">Start Date
              @if (getFieldInfo('startDate'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              dateFormat="mm/dd/yy" formControlName="startDate" [style]="{'width':'100%'}"></p-calendar>
              @if (submitted && startDate && startDate.invalid) {
                <span style="color:var(--al-danger)">Start Date is required</span>
              }
          </div>
        </div>
        <div class="al-vital">
          <div class="mb-1">
            <label for="dueDate" class="form-label">Due Date
              <span class="history-icon"
                [pTooltip]="projectForm.getRawValue().dueDateChangeCount > 0 ? 'Click to view Audit History' : 'No Audit History Available'" appActionTooltip>
                <i class="mdi mdi-history" [ngStyle]="{
                      color: projectForm.getRawValue().dueDateChangeCount > 0 ? 'var(--al-success)' : 'var(--al-danger)',
                      opacity: projectForm.getRawValue().dueDateChangeCount > 0 ? 1 : 0.5,
                      cursor: projectForm.getRawValue().dueDateChangeCount > 0 ? 'pointer' : 'not-allowed'
                    }" [class.disabled]="projectForm.getRawValue().dueDateChangeCount === 0"
                  (click)="projectForm.getRawValue().dueDateChangeCount > 0 && showAuditData(projectForm.getRawValue().id, 'dueDate', 'Due Date')"
                tabindex="0"></i>
              </span>
              @if (getFieldInfo('dueDate'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
              dateFormat="mm/dd/yy" formControlName="dueDate" [style]="{'width':'100%'}"></p-calendar>
              @if (submitted && dueDate && dueDate.invalid) {
                <span style="color:var(--al-danger)">Due Date is required</span>
              }
              @let formOverdue = dueDateOverdueDays(projectForm.getRawValue().dueDate, projectForm.getRawValue().statusCode, projectForm.getRawValue().closedDate);
              @if (formOverdue) {
                <span class="pd-overdue pd-overdue-field">{{ formOverdue }} {{ formOverdue === 1 ? 'day' : 'days' }} overdue</span>
              }
          </div>
        </div>
        </div>
        <div class="al-vital">
          <div class="mb-1">
            <label for="lpc" class="form-label">LPC
              @if (getFieldInfo('lpcUserId'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <p-dropdown appendTo="body" formControlName="lpcUserId" [options]="lpcUsersList" optionLabel="mainEmail"
                optionValue="id" [showClear]="true" [filter]="true" [style]="{'width':'100%'}"
              placeholder="Select LPC"></p-dropdown>
              @if (submitted && lpcUserId && lpcUserId.invalid) {
                <span style="color:var(--al-danger)">LPC is required</span>
              }
          </div>
        </div>
      </div>
      <p-accordion [multiple]="true" [activeIndex]="openProjectGroups"
        (activeIndexChange)="onProjectGroupToggle($event)" styleClass="al-groups">
        <p-accordionTab>
          <ng-template pTemplate="header">
            <span class="al-group-head">
              <span>Project identity</span>
              <span class="al-group-count">{{ projectForm.get('organizationName')?.value }}</span>
            </span>
          </ng-template>
      <div class="row al-identity-row">
        <div class="col-xl-4 al-identity-col">
          <div class="mb-1">
            <label for="organizationId" class="form-label">Organization Name
              @if (getFieldInfo('organizationName'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip
                  [infoText]="info.informationText"></info-tooltip>
                }
              }
              </label><span style="color:var(--al-danger);">*</span>
              <p-dropdown #orgDropdown appendTo="body" formControlName="organizationId" [options]="allOrganisations"
                optionLabel="name" optionValue="id" [showClear]="true" [filter]="true"
                [style]="{'width':'100%'}" placeholder="Select Organization"
              (onChange)="getAllMatter($event)"></p-dropdown>
            </div>
            <div class="mb-1">
              <label for="matterId" class="form-label">Matter Name
                @if (getFieldInfo('matterName'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip
                    [infoText]="info.informationText"></info-tooltip>
                  }
                }
                </label><span style="color:var(--al-danger);">*</span>
                <p-dropdown #matterDropdown appendTo="body" formControlName="matterId" [options]="mattersList"
                  optionLabel="name" optionValue="id" [showClear]="true" [filter]="true"
                  [style]="{'width':'100%'}" placeholder="Select Matter"
                (onChange)="getOrganizationsByMatterId($event)"></p-dropdown>
              </div>
        </div>
        <div class="col-xl-8">
            <div class="al-contacts-field">
              @if (projectForm.getRawValue().id) {
                <ng-container *ngTemplateOutlet="contactsSummary; context: { $implicit: editContacts, source: 'edit' }"></ng-container>
              } @else {
                <span class="pd-label">Contacts</span>
                <p class="pd-empty pd-contacts-empty">Save the project first, then add contacts.</p>
              }
            </div>
        </div>
      </div>
          <div class="mb-1">
            <label for="description" class="form-label">Description
              @if (getFieldInfo('description'); as info) {
                @if (info.showInformation === 'Yes' && info.informationText) {
                  <info-tooltip [infoText]="info.informationText"></info-tooltip>
                }
              }
            </label>
            <textarea placeholder="" class="form-control" formControlName="description" appSpellCheck></textarea>
          </div>
        </p-accordionTab>
        <p-accordionTab>
          <ng-template pTemplate="header">
            <span class="al-group-head">
              <span>Schedule &amp; template</span>
              <span class="al-group-count">{{ projectForm.getRawValue().actualTime || '00:00' }} actual &middot; est {{ projectForm.getRawValue().estimatedTime || '00:00' }}</span>
            </span>
          </ng-template>
          <div class="row">
              <!-- Close Date -->
              <div class="col-xl-4">
                <div class="mb-1">
                  <label for="closedDate" class="form-label">Close Date
                    @if (getFieldInfo('closedDate'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip
                        [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <p-calendar appendTo="body" [minDate]="projectdueDate" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="2010:2030" dateFormat="mm/dd/yy"
                  formControlName="closedDate" [style]="{'width':'100%'}"></p-calendar>
                </div>
              </div>
              <!-- Estimated Time -->
              <div class="col-xl-4">
                <div class="mb-1">
                  <label for="estimatedTime" class="form-label">Estimated Time(HH:MM)
                    @if (getFieldInfo('estimatedTime'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip
                        [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <span class="al-field-tooltip" pTooltip="Read-only here; this is the project's current time estimate."
                    appActionTooltip>
                    <input class="form-control" type="text" readonly formControlName="estimatedTime"
                      id="estimatedTime">
                  </span>
                </div>
              </div>
              <!-- Actual Time -->
              <div class="col-xl-4">
                <div class="mb-1">
                  <label for="actualTime" class="form-label">Actual Time(HH:MM)
                    @if (getFieldInfo('actualTime'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip
                        [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  <span class="al-field-tooltip" pTooltip="Read-only here; this reflects time recorded against the project."
                    appActionTooltip>
                    <input class="form-control" type="text" readonly formControlName="actualTime" id="actualTime">
                  </span>
                </div>
              </div>
              <!-- Template Assigned -->
              <div class="col-xl-4">
                <div class="mb-1">
                  <label for="projectTemplateId" class="form-label">Template Assigned
                    @if (getFieldInfo('projectTemplateId'); as info) {
                      @if (info.showInformation === 'Yes' && info.informationText) {
                        <info-tooltip
                        [infoText]="info.informationText"></info-tooltip>
                      }
                    }
                  </label>
                  @if (newProject) {
                    <select class="form-select" formControlName="projectTemplateId">
                      <option [value]="" selected>Select</option>
                      @for (template of projectTemplates; track template) {
                        <option [ngValue]="template.projectTemplate.id"
                          [selected]="template.projectTemplate.id == projectForm.value.templateId">
                        {{template.projectTemplate.description}}</option>
                      }
                    </select>
                  }
                  @if (!newProject) {
                    <span class="al-field-tooltip" pTooltip="The assigned template cannot be changed after project creation."
                      appActionTooltip>
                      <input class="form-control" type="text" readonly formControlName="projectTemplateName"
                        id="projectTemplateName">
                    </span>
                  }
                </div>
              </div>
          </div>
        </p-accordionTab>
        <p-accordionTab>
          <ng-template pTemplate="header">
            <span class="al-group-head">
              <span>Budget &amp; type</span>
              <span class="al-group-count">{{ projectForm.getRawValue().actualSpend || 0 }} of {{ projectForm.getRawValue().estimatedBudget || 0 }}</span>
            </span>
          </ng-template>
          <div class="row">
                <!-- Estimated Budget -->
                <div class="col-xl-4">
                  <div class="mb-1">
                    <label for="estimatedBudget" class="form-label">Estimated Budget
                      @if (getFieldInfo('estimatedBudget'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip
                          [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                    </label>
                    <span class="al-field-tooltip" pTooltip="Read-only here; this is the project's current budget."
                      appActionTooltip>
                      <input class="form-control" type="text" readonly formControlName="estimatedBudget"
                        id="estimatedBudget">
                    </span>
                  </div>
                </div>
                <!-- Actual Spend -->
                <div class="col-xl-4">
                  <div class="mb-1">
                    <label for="actualSpend" class="form-label">Actual Spend
                      @if (getFieldInfo('actualSpend'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip
                          [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                    </label>
                    <span class="al-field-tooltip" pTooltip="Read-only here; this reflects spend recorded against the project."
                      appActionTooltip>
                      <input class="form-control" type="text" readonly formControlName="actualSpend" id="actualSpend">
                    </span>
                  </div>
                </div>
                <!-- Enforced Estimated Time -->
                <div class="col-xl-4">
                  <div class="mb-1">
                    <label for="isEnforceEstimatedTime" class="form-label">Enforced Estimated Time
                      @if (getFieldInfo('isEnforceEstimatedTime'); as info) {
                        @if (info.showInformation === 'Yes' && info.informationText) {
                          <info-tooltip
                          [infoText]="info.informationText"></info-tooltip>
                        }
                      }
                      </label><span style="color:var(--al-danger);">*</span>
                      <select class="form-select" formControlName="isEnforceEstimatedTime">
                        <option [value]="" selected>Select</option>
                        <option value="Yes" selected>Yes</option>
                        <option value="No" selected>No</option>
                      </select>
                      @if (submitted && isEnforceEstimatedTime && isEnforceEstimatedTime.invalid) {
                        <span style="color:var(--al-danger)"
                          >Enforced
                        Estimated Time is required</span>
                      }
                    </div>
                  </div>
                  <!-- Project Type -->
                  <div class="col-xl-4">
                    <div class="mb-1">
                      <label for="projectTypeId" class="form-label">Project Type
                        @if (getFieldInfo('projectTypeId'); as info) {
                          @if (info.showInformation === 'Yes' && info.informationText) {
                            <info-tooltip
                            [infoText]="info.informationText"></info-tooltip>
                          }
                        }
                        </label><span style="color:var(--al-danger);">*</span>
                        <p-dropdown appendTo="body" formControlName="projectTypeId" [options]="projectTypeCodes" optionLabel="label"
                          optionValue="id" [showClear]="true" [filter]="true" [style]="{'width':'100%'}"
                        placeholder="Select Project Type"></p-dropdown>
                        @if (submitted && projectTypeId && projectTypeId.invalid) {
                          <span style="color:var(--al-danger)">Project
                          Type is required</span>
                        }
                      </div>
                    </div>
          </div>
        </p-accordionTab>
        <p-accordionTab>
          <ng-template pTemplate="header">
            <span class="al-group-head">
              <span>Billing</span>
              <span class="al-group-count">{{ projectForm.getRawValue().isBillable === 'No' ? 'Non-billable' : 'Billable' }}</span>
            </span>
          </ng-template>
          <div class="row">
                          <!-- Billable -->
                          <div class="col-xl-4">
                            <div class="mb-1">
                              <label for="isBillable" class="form-label">Billable
                                @if (getFieldInfo('isBillable'); as info) {
                                  @if (info.showInformation === 'Yes' && info.informationText) {
                                    <info-tooltip
                                    [infoText]="info.informationText"></info-tooltip>
                                  }
                                }
                                </label><span style="color:var(--al-danger);">*</span>
                                <select class="form-select" id="isBillable" formControlName="isBillable">
                                  <option [value]="" selected>Select</option>
                                  <option value="Yes" selected>Yes</option>
                                  <option value="No" selected>No</option>
                                </select>
                                @if (submitted && isBillable && isBillable.invalid) {
                                  <span style="color:var(--al-danger)">Billable is
                                  required</span>
                                }
                              </div>
                            </div>
                            <!-- Non Billable Reason -->
                            <div class="col-xl-4">
                              <div class="mb-1">
                                <label for="nonBillableReason" class="form-label">Non Billable Reason
                                  @if (getFieldInfo('nonBillableReason'); as info) {
                                    @if (info.showInformation === 'Yes' && info.informationText) {
                                      <info-tooltip
                                      [infoText]="info.informationText"></info-tooltip>
                                    }
                                  }
                                </label>
                                @if (isBillable.value=='No') {
                                  <span style="color:var(--al-danger);">*</span>
                                }
                        <p-dropdown inputId="nonBillableReason" formControlName="nonBillableReason"
                          [attr.aria-describedby]="nonBillableReason?.disabled ? 'nonBillableReasonHelp' : null" [options]="[
                                    {label: 'Pre-Invoiced', value: 'Pre-Invoiced'},
                                    {label: 'Managed Service Project', value: 'Managed Service Project'},
                                    {label: 'Internal or Administrative Task', value: 'Internal or Administrative Task'},
                                    {label: 'Error Correction', value: 'Error Correction'},
                                    {label: 'Client Courtesy', value: 'Client Courtesy'},
                                    {label: 'Business Development', value: 'Business Development'},
                                    {label: 'Knowledge Management', value: 'Knowledge Management'},
                                    {label: 'Professional Development', value: 'Professional Development'},
                                    {label: 'Marketing and Thought Leadership', value: 'Marketing and Thought Leadership'},
                                    {label: 'Fixed Fee Project', value: 'Fixed Fee Project'}
                                ]" appendTo="body" optionLabel="label" optionValue="value" [showClear]="true"
                                  [filter]="true" [style]="{'width':'100%'}"
                                placeholder="Select Non Billable Reason"></p-dropdown>
                                @if (nonBillableReason?.disabled) {
                                  <small id="nonBillableReasonHelp" class="al-field-help">Available when Billable is set to No.</small>
                                }
                                @if (submitted && nonBillableReason && nonBillableReason.invalid) {
                                  <span style="color:var(--al-danger)">Non
                                    Billable Reason
                                  is required</span>
                                }
                              </div>
                            </div>
                            <!-- Hold Time Until Completed -->
                            <div class="col-xl-4">
                              <div class="mb-1">
                                <label for="holdTimeUntilCompleted" class="form-label">Hold Time Until Completed
                                  @if (getFieldInfo('holdTimeUntilCompleted'); as info) {
                                    @if (info.showInformation === 'Yes' && info.informationText) {
                                      <info-tooltip
                                      [infoText]="info.informationText"></info-tooltip>
                                    }
                                  }
                                  </label><span style="color:var(--al-danger);">*</span>
                                  <select class="form-select" id="holdTimeUntilCompleted"
                                    formControlName="holdTimeUntilCompleted">
                                    <option value="" selected>Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                  </select>
                                  @if (submitted && holdTimeUntilCompleted && holdTimeUntilCompleted.invalid) {
                                    <span style="color:var(--al-danger)"
                                      >Hold Time
                                    Until Completed is required</span>
                                  }
                                </div>
                              </div>
                              <!-- Requested By -->
                              @if (projectForm.getRawValue().isForceRequestedBy=='Yes') {
                                <div class="col-xl-4">
                                  <div class="mb-1">
                                    <label for="requestedBy" class="form-label">Requested By
                                      @if (getFieldInfo('requestedBy'); as info) {
                                        @if (info.showInformation === 'Yes' && info.informationText) {
                                          <info-tooltip
                                          [infoText]="info.informationText"></info-tooltip>
                                        }
                                      }
                                    </label>
                                    <select class="form-select" formControlName="requestedBy">
                                      <option [value]="" selected>Select</option>
                                      @for (name of requestedByOptions; track name) {
                                        <option [ngValue]="name"
                                          [selected]="projectForm.getRawValue().requestedBy && name == projectForm.getRawValue().requestedBy.toString()">
                                        {{ name }}</option>
                                      }
                                    </select>
                                    @if (submitted && requestedBy && requestedBy.invalid) {
                                      <span style="color:var(--al-danger)">Requested By
                                      is required</span>
                                    }
                                  </div>
                                </div>
                              }
          </div>
        </p-accordionTab>
        <p-accordionTab>
          <ng-template pTemplate="header">
            <span class="al-group-head">
              <span>Invoicing</span>
              <span class="al-group-count">Pre-invoiced {{ projectForm.getRawValue().isPreInvoiced || 'No' }}</span>
            </span>
          </ng-template>
          <div class="row">
                              <!-- Pre-Invoiced -->
                              <div class="col-xl-4">
                                <div class="mb-1">
                                  <label for="isPreInvoiced" class="form-label">Pre-Invoiced
                                    @if (getFieldInfo('isPreInvoiced'); as info) {
                                      @if (info.showInformation === 'Yes' && info.informationText) {
                                        <info-tooltip
                                        [infoText]="info.informationText"></info-tooltip>
                                      }
                                    }
                                    </label><span style="color:var(--al-danger);">*</span>
                                    <select class="form-select" id="isPreInvoiced" formControlName="isPreInvoiced"
                                      [attr.aria-describedby]="isPreInvoiced?.disabled ? 'preInvoicedHelp' : null"
                                      (change)="checkPreInvoiced($event.target.value)">
                                      <option value="" selected>Select</option>
                                      <option value="Yes">Yes</option>
                                      <option value="No">No</option>
                                    </select>
                                    @if (isPreInvoiced?.disabled) {
                                      <small id="preInvoicedHelp" class="al-field-help">{{ getPreInvoicedDisabledReason() }}</small>
                                    }
                                    @if (submitted && isPreInvoiced && isPreInvoiced.invalid) {
                                      <span style="color:var(--al-danger)">Pre-Invoiced
                                        is
                                      required</span>
                                    }
                                  </div>
                                </div>
                                <!-- Invoice Number -->
                                <div class="col-xl-4">
                                  <div class="mb-1">
                                    <label for="invoiceNumber" class="form-label"> Invoice Number
                                      @if (getFieldInfo('invoiceNumber'); as info) {
                                        @if (info.showInformation === 'Yes' && info.informationText) {
                                          <info-tooltip
                                          [infoText]="info.informationText"></info-tooltip>
                                        }
                                      }
                                    </label>
                                    <input class="form-control" type="text" formControlName="invoiceNumber" id="invoiceNumber"
                                      [attr.aria-describedby]="invoiceNumber?.disabled ? 'invoiceNumberHelp' : null" appSpellCheck>
                                    @if (invoiceNumber?.disabled) {
                                      <small id="invoiceNumberHelp" class="al-field-help">{{ getInvoiceNumberDisabledReason() }}</small>
                                    }
                                    @if (submitted && invoiceNumber && invoiceNumber.errors?.pattern) {
                                      <span style="color:var(--al-danger)">Only
                                        _ and - are
                                      allowed in Invoice Number</span>
                                    }
                                  </div>
                                </div>
                                <!-- Invoice Paid -->
                                <div class="col-xl-4">
                                  <div class="mb-1">
                                    <label class="form-label">&nbsp;</label>
                                    <div class="form-check">
                                      <input class="form-check-input" id="isInvoicePaid" type="checkbox"
                                        formControlName="isInvoicePaid"
                                        [attr.aria-describedby]="projectForm.get('isInvoicePaid')?.disabled ? 'invoicePaidHelp' : null">
                                      <label class="form-check-label" for="isInvoicePaid">
                                        Invoice Paid
                                        @if (getFieldInfo('isInvoicePaid'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                    </div>
                                    @if (projectForm.get('isInvoicePaid')?.disabled) {
                                      <small id="invoicePaidHelp" class="al-field-help">{{ getInvoicePaidDisabledReason() }}</small>
                                    }
                                  </div>
                                </div>
                              </div>
                              </p-accordionTab>
                              </p-accordion>
                              </div>

                              @if (showProjectNotesPanel || !projectDialog) {
                                <div class="al-notes-col" [class.has-comments]="!!projectForm.getRawValue().id">
                                  <div class="al-panel-head">
                                    <div>
                                      <h4>Project notes</h4>
                                      <p>Project-level notes saved with this project.</p>
                                    </div>
                                    @if (getFieldInfo('notes'); as info) {
                                      @if (info.showInformation === 'Yes' && info.informationText) {
                                        <info-tooltip [infoText]="info.informationText"></info-tooltip>
                                      }
                                    }
                                  </div>
                                  <textarea placeholder="" class="form-control al-notes" formControlName="notes"
                                    appSpellCheck></textarea>
                                  @if (projectForm.getRawValue().id) {
                                    <section class="al-comments-block" aria-label="Project comments">
                                      <div class="al-panel-head">
                                        <div>
                                          <h4>Comments</h4>
                                          <p>Posted right away. Not part of Save.</p>
                                        </div>
                                      </div>
                                      <app-comments [targetType]="'Project'" [targetId]="projectForm.getRawValue().id"></app-comments>
                                    </section>
                                  }
                                </div>
                              } @else {
                                <div class="al-notes-rail" role="button" tabindex="0" (click)="showProjectNotesPanel = true"
                                  (keydown.enter)="showProjectNotesPanel = true" (keydown.space)="showProjectNotesPanel = true"
                                  aria-label="Show project notes">
                                  <span class="al-rail-label">Project notes</span>
                                </div>
                              }
                              </div>
                              </div>
                            </form>
                          </div>

                          @if (!viewOnly && !projectDialog) {
                            <div class="row">
                              <div class="col-xl-12">
                                <div class="button-items" style="display: flex; justify-content: flex-end; align-items: center; gap: 12px; padding: 14px 1% 1%; border-top: 1px solid var(--al-border);">
                                  <span appActionTooltip [actionTooltipDelay]="0" [pTooltip]="projectSaveDisabled ? getSaveDisabledReason() : 'Save Project'"
                                    [actionDisabled]="projectSaveDisabled">
                                    <button [disabled]="projectSaveDisabled" class="btn btn-primary" (click)="saveProject(true)"> Save @if (btnLoading) {
                                      <i
                                      style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                                    }</button>
                                  </span>
                                  <button class="btn btn-secondary" (click)="closeDialog()" pTooltip="Cancel" appActionTooltip> Cancel </button>
                                </div>
                              </div>
                            </div>
                          }
                        </ng-template>

                        <!-- Project Edit Dialog -->
                        <p-dialog [(visible)]="projectDialog" (onHide)="closeDialog()" (onShow)="focusNewProjectName()"
                          [style]="{'width': 'min(1536px, 96%)', 'max-height':'calc(100vh - 40px)'}"
                          [resizable]="false" [draggable]="false" [modal]="true" [closable]="false" [closeOnEscape]="false"
                          styleClass="p-fluid al-task-dialog al-project-dialog">
                          <ng-template pTemplate="header">
                            <div class="al-project-dialog-header">
                              <div class="al-dialog-heading">
                                <span class="p-dialog-title al-task-name">{{ newProject ? 'New project' : (projectForm.get('name')?.value || 'Untitled project') }}</span>
                                <span class="al-task-meta">
                                  @if (projectForm.get('organizationName')?.value) {
                                    <span>{{ projectForm.get('organizationName')?.value }}</span>
                                  }
                                  @if (projectForm.get('matterName')?.value) {
                                    <span class="al-meta-dot">·</span><span>{{ projectForm.get('matterName')?.value }}</span>
                                  }
                                  @if (projectForm.getRawValue().id) {
                                    <span class="al-meta-dot">·</span><span class="al-id-wrap"><button type="button" class="pw-id" [class.is-copied]="copiedKey === 'edit-project-id'"
                                      (click)="copyToClipboard('edit-project-id', projectForm.getRawValue().id)"
                                      [attr.aria-label]="'Copy project ID ' + projectForm.getRawValue().id">
                                      {{ copiedKey === 'edit-project-id' ? 'Copied!' : 'Project #' + projectForm.getRawValue().id }}
                                      @if (copiedKey !== 'edit-project-id') { <i class="mdi mdi-content-copy"></i> }
                                    </button></span>
                                  }
                                  @if (hasProjectBudget) {
                                    <span class="al-meta-dot">·</span>
                                    <span class="al-budget" [class.is-over]="isOverBudget">
                                      <span class="al-budget-k">Budget used</span>
                                      <span class="al-budget-v">{{ budgetUsedPercent | number:'1.0-0' }}%</span>
                                      <span class="al-budget-of">{{ projectForm.getRawValue().actualSpend || 0 }} of {{ projectForm.getRawValue().estimatedBudget }}</span>
                                      <span class="al-budget-bar" role="img"
                                        [attr.aria-label]="'Budget used ' + (budgetUsedPercent | number:'1.0-0') + '%' + (isOverBudget ? ', over estimate' : '')">
                                        <span class="al-budget-fill" [style.width.%]="budgetUsedPercent"></span>
                                      </span>
                                      @if (isOverBudget) {
                                        <span class="al-budget-flag">Over estimate</span>
                                      }
                                    </span>
                                  }
                                </span>
                              </div>
                              <div class="al-project-actions">
                              @if (projectForm.dirty && !viewOnly) {
                                <span class="al-project-dirty">Unsaved changes</span>
                              }
                              <button type="button" class="al-project-hdr-btn"
                                [attr.aria-pressed]="showProjectNotesPanel" (click)="showProjectNotesPanel = !showProjectNotesPanel"
                                [pTooltip]="showProjectNotesPanel ? 'Hide project notes' : 'Show project notes'" appActionTooltip>
                                <i class="mdi" [class.mdi-page-layout-sidebar-right]="showProjectNotesPanel"
                                  [class.mdi-page-layout-body]="!showProjectNotesPanel"></i>
                                {{ showProjectNotesPanel ? 'Hide notes' : 'Show notes' }}
                              </button>
                              @if (!viewOnly) {
                                <span appActionTooltip [actionTooltipDelay]="0" [pTooltip]="projectSaveDisabled ? getSaveDisabledReason() : 'Update project'"
                                  [actionDisabled]="projectSaveDisabled">
                                  <button type="button" [disabled]="projectSaveDisabled" class="al-project-hdr-btn al-project-hdr-btn-primary"
                                    (click)="saveProject(true)"> Update Project @if (btnLoading) {
                                    <i style="margin-left: 6px;" class="fa fa-solid fa-sync fa-spin"></i>
                                  }</button>
                                </span>
                              }
                              <button type="button" class="al-project-dialog-close" (click)="confirmCloseProject()" pTooltip="Close"
                                appActionTooltip aria-label="Close project">
                                <i class="mdi mdi-window-close"></i>
                              </button>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="content">
                            <div class="al-dialog-top">
                              @if (submitted) {
                                @let missingRequired = getMissingRequiredProjectFields();
                                @if (missingRequired.length > 0) {
                                  <div class="al-validation-banner">
                                    <i class="mdi mdi-alert-circle-outline"></i>
                                    <span>
                                      @if (missingRequired.length === 1) {
                                        {{ missingRequired[0] }} is required before you can save.
                                      } @else {
                                        Please complete the required fields: {{ missingRequired.join(', ') }}.
                                      }
                                    </span>
                                  </div>
                                }
                              }
                            </div>
                            <div class="card project-view">
                              <ng-container *ngTemplateOutlet="projectEditTemplate"></ng-container>
                            </div>
                          </ng-template>
                        </p-dialog>

                        <p-dialog [(visible)]="assignTaskDialogue" (onHide)="closeAssignTaskDialogue()" [style]="{width: '80%'}"
                          [resizable]="false" [draggable]="false" [header]="title" [modal]="true" styleClass="p-fluid"
                          class="">
                          <app-notification [errorMsg]="errorMsg"></app-notification>
                          <ng-template pTemplate="content">
                            @if (tasksloading) {
                              <div class="loading-overlay">
                                <div class="loading-spinner">
                                  <i class="fas fa-spinner fa-spin fa-3x"></i>
                                </div>
                              </div>
                            }
                            <div class="dialog-body">
                              <div class="card">
                                <div class="card-body">
                                  <div class="row" style="margin-bottom:2%;">
                                    <div class="col-sm-2">
                                      <label class="form-label">Organization Name
                                        @if (getFieldInfo('organizationName'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                      <input class="form-control" type="text" readonly [(ngModel)]="orgName">
                                    </div>
                                    <div class="col-sm-2">
                                      <label class="form-label">Matter Name
                                        @if (getFieldInfo('matterName'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                      <input class="form-control" type="text" readonly [(ngModel)]="matterName">
                                    </div>
                                    <div class="col-sm-2">
                                      <label class="form-label">Project Name
                                        @if (getFieldInfo('name'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                      <input class="form-control" type="text" readonly [(ngModel)]="selectedProjectName">
                                    </div>
                                    <div class="col-sm-4">
                                      <label for="assignTask" class="form-label">Task
                                        @if (getFieldInfo('taskName'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                        </label><span style="color:var(--al-danger);">*</span>
                                        <div class="custom-tree-dropdown-container">

                                          <div class="p-inputtext p-component p-dropdown p-dropdown-label"
                                            [ngClass]="{'p-disabled': assignLoading}" (click)="!assignLoading && toggleDropdown()"
                                            [attr.aria-expanded]="isDropdownOpen" role="button" tabindex="0"
                                            pTooltip="Select a task" appActionTooltip>
                                            <span>{{ displaySelectedTask }}</span>
                                            @if (selectedTaskNode) {
                                              <i class="pi pi-times-circle" pTooltip="Clear selected task" appActionTooltip
                                              (click)="$event.stopPropagation(); clearSelection()"></i>
                                            }
                                            <i class="pi"
                                            [ngClass]="{'pi-chevron-down': !isDropdownOpen, 'pi-chevron-up': isDropdownOpen}"></i>
                                          </div>

                                          <div class="p-dropdown-panel" [class.p-dropdown-panel-open]="isDropdownOpen"
                                            >
                                            <div class="p-dropdown-items-wrapper" >
                                              <p-tree [value]="taskTreeNodes" selectionMode="single"
                                                (onNodeSelect)="onNodeSelect($event)" [filter]="true" [filterBy]="'label'"
                                                [filterMode]="'lenient'" appendTo="body" styleClass="p-fluid">
                                                <ng-template let-node pTemplate="default">
                                                  <span
                                                    [attr.title]="node.data?.qbDescription ? node.data.qbDescription : null"
                                                    [ngClass]="{'text-muted-header': node.disabled}">
                                                    {{ node.label }}
                                                  </span>
                                                </ng-template>
                                              </p-tree>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-sm-2">
                                        <div style="height: 50%;"></div>
                                        <span appActionTooltip [pTooltip]="!newTask ? getCreateTaskDisabledReason() : 'Create Task'"
                                          [actionDisabled]="!newTask">
                                          <button class="btn btn-primary btn-sm" [disabled]="!newTask" (click)="assignTask()">Create
                                          Task</button>
                                        </span>
                                        @if (assignLoading) {
                                          <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                                        }
                                        @if (deleteTaskLoading) {
                                          <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                                        }
                                      </div>
                                    </div>

                                    <p-table [(value)]="selectedProject.projectTasks" [scrollable]="true"
                                      scrollHeight="35vh"
                                      responsiveLayout="scroll"
                                      [autoLayout]="true"
                                      [rowHover]="true"
                                      [style]="{width: '100%'}">
                                      <ng-template pTemplate="header">
                                        <tr>
                                          <th>Task Name</th>
                                          <th>Task Type</th>
                                          <th>Practice Area</th>
                                          <th>Description</th>
                                          <th>Rate</th>
                                          <th>Rate Type Code</th>
                                          <th>Task Status</th>
                                          <th>Disbursement Related</th>
                                          <th style="width:6rem">Delete</th>
                                        </tr>
                                      </ng-template>
                                      <ng-template pTemplate="body" let-task>
                                        <tr>
                                          <td>{{task.taskName}}</td>
                                          <td>{{task.taskTypeCode}}</td>
                                          <td>{{task.practiceAreaCode}}</td>
                                          <td>{{task.description}}</td>
                                          <td>{{task.rate}}</td>
                                          <td>{{task.rateTypeCode}}</td>
                                          <td>{{task.statusCode}}</td>
                                          <td>{{task.disbursementRelated}}</td>
                                          <td style="width:6rem">
                                            <div class="flex justify-content-between align-items-center">
                                              <span appActionTooltip [pTooltip]="task.statusCode!='Open' ? 'Only tasks with status Open can be deleted.' : 'Delete Task'"
                                                [actionDisabled]="task.statusCode!='Open'">
                                                <button class="btn btn-warning btn-sm" [disabled]="task.statusCode!='Open'"
                                                  (click)="deleteTask(task)"><i class="mdi mdi-trash-can" width="44"
                                                height="44"></i></button>
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      </ng-template>
                                      <ng-template pTemplate="emptymessage" let-columns>
                                        <tr>
                                          <td [attr.colspan]="columns && columns.length">
                                            No records found
                                          </td>
                                        </tr>
                                      </ng-template>
                                    </p-table>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </p-dialog>


                          <p-dialog [resizable]="false" [draggable]="false" [(visible)]="confirmationDialog" (onHide)="closeDialog()"
                            [style]="{'width': '40%', 'max-height':'85%'}" header="Confirm to Proceed" [modal]="true" styleClass="p-fluid">
                            <ng-template pTemplate="content">
                              <form [formGroup]="projectForm">
                                <div class="row">
                                  <div class="col-xl-4">
                                    <div class="mb-1">
                                      <label for="name" class="form-label mb-1">Project Name
                                        @if (getFieldInfo('name'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                      <input class="form-control p-2" type="text" readonly formControlName="name" id="name">
                                    </div>
                                  </div>
                                  <div class="col-xl-4">
                                    <div class="mb-1">
                                      <label for="orgName" class="form-label mb-1">Organization Name
                                        @if (getFieldInfo('organizationName'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                      <input class="form-control p-2" type="text" readonly formControlName="orgName" id="orgName">
                                    </div>
                                  </div>
                                  <div class="col-xl-4">
                                    <div class="mb-1">
                                      <label for="matterName" class="form-label mb-1">Matter Name
                                        @if (getFieldInfo('matterName'); as info) {
                                          @if (info.showInformation === 'Yes' && info.informationText) {
                                            <info-tooltip
                                            [infoText]="info.informationText"></info-tooltip>
                                          }
                                        }
                                      </label>
                                      <input class="form-control p-2" type="text" readonly formControlName="matterName"
                                        id="matterName">
                                    </div>
                                  </div>
                                  <div class="question">
                                    <p>{{confirmationDialogMessage}}</p>
                                    <button type="submit" class="btn btn-success" (click)="deleteTaskAPI(taskForm)"
                                    style="margin-left: 2%;margin-right: 3%;" pTooltip="Yes, delete this task" appActionTooltip>Yes</button>
                                    <button type="button" class="btn btn-danger" pTooltip="No, keep task" appActionTooltip>No</button>
                                  </div>
                                </div>
                              </form>
                            </ng-template>
                          </p-dialog>

                          <app-confirmation-alert [showAlert]="showConfirmAlert" [message]="confirmMessage"
                          (response)="saveProject(null,$event=='Yes'?true:false)"></app-confirmation-alert>

                          <app-confirmation-alert [showAlert]="showBillingConfirmAlert" [message]="confirmMessage"
                          (response)="submitToBilling(null,$event=='Yes'?true:false)"></app-confirmation-alert>

                          <app-confirmation-alert [showAlert]="showAssignConfirmAlert" [message]="confirmMessage"
                          (response)="assignTask($event=='Yes'?true:false)"></app-confirmation-alert>

                          <p-dialog [(visible)]="auditDialog" (onHide)="closeAuditDialog()" [style]="{'width': '60%', 'max-height':'75%'}"
                            [resizable]="false" [draggable]="false" [header]="auditTitle" [modal]="true" styleClass="p-fluid">
                            <ng-template pTemplate="content">
                              <app-audit-table
                                [tableName]="'al_project'"
                                [recordId]="auditRecordId"
                              [fieldName]="auditField"></app-audit-table>
                            </ng-template>
                          </p-dialog>

                          <p-dialog [(visible)]="reminderDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
                            [style]="{width: '80%'}" [header]="'Reminders'+': (Project Name: ' + (selectedProject?.name) + ')'" [modal]="true" styleClass="p-fluid">
                            <ng-template pTemplate="content">
                              <app-reminder [projectId]="selectedProject?.id"></app-reminder>
                            </ng-template>
                          </p-dialog>


                          <p-dialog [(visible)]="reminderNotificationDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
                            [style]="{width: '70%'}" [header]="'Reminder Notifications'+': (Project Name: ' + (selectedProject?.name) + ')'" [modal]="true" styleClass="p-fluid">
                            <ng-template pTemplate="content">
                              <app-reminder-notifications [notifications]="selectedProject?.unreadReminderNotifications"></app-reminder-notifications>
                            </ng-template>
                          </p-dialog>

                          <p-dialog [(visible)]="gridSettingsDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
                            [style]="{width: '70%'}" [header]="'Grid Settings'" [modal]="true" styleClass="p-fluid">
                            <ng-template pTemplate="content">
                              <app-grid-settings-mapper [category]="'Project'" [availableColumns]="availableColumns" [customCols]="customCols" [defaultColumns]="getDefaultGridColumns()" (onSaved)="saveCustomSettings();closeSettingsDialog();"></app-grid-settings-mapper>
                            </ng-template>
                          </p-dialog>

<ng-template #contactsSummary let-contacts let-source="source">
  @let canManage = canManageContacts(source);
  <div class="pd-contacts-head">
    <span class="pd-label">Contacts
      @if (contacts.length) { <span class="pd-count">{{ contacts.length }}</span> }
    </span>
    @if (canManage) {
      <button type="button" class="btn btn-light btn-sm pd-manage" (click)="openContactsManager(source)">
        <i class="mdi mdi-account-cog-outline"></i> Manage contacts
      </button>
    }
  </div>
  @if (contacts.length) {
    <ul class="pd-contact-cards" role="list">
      @for (contact of contacts.slice(0, contactPreviewLimit); track contact.contactId) {
        <li class="pd-contact-card">
          <span class="pd-contact-name">
            <span class="pd-contact-label">{{ contactName(contact) }}</span>
            @if (contact.isPrimary) { <span class="pd-pill">Primary</span> }
            @if (!contact.isActive) { <span class="pd-pill is-muted">Inactive</span> }
          </span>
          @if (contact.email) {
            <span class="pd-contact-meta">
              <a class="pd-link" [href]="'mailto:' + contact.email">{{ contact.email }}</a>
              <button type="button" class="pd-copy" [class.is-copied]="copiedKey === source + '-email-' + contact.contactId"
                (click)="copyToClipboard(source + '-email-' + contact.contactId, contact.email)" [attr.aria-label]="'Copy email ' + contact.email">
                @if (copiedKey === source + '-email-' + contact.contactId) { Copied! } @else { <i class="mdi mdi-content-copy"></i> }
              </button>
            </span>
          }
        </li>
      }
    </ul>
    @if (contacts.length > contactPreviewLimit) {
      <button type="button" class="pd-more pd-view-all" (click)="openContactsManager(source)">
        View {{ contacts.length - contactPreviewLimit }} more <i class="mdi mdi-arrow-right"></i>
      </button>
    }
  } @else {
    <p class="pd-empty pd-contacts-empty">No contacts on this project yet.
      @if (canManage) { <button type="button" class="pd-more pd-inline" (click)="openContactsManager(source)">Add contacts</button> }
    </p>
  }
</ng-template>

<app-project-contacts-manager [(visible)]="contactsManagerVisible"
  [projectId]="contactsManagerTarget?.projectId ?? null" [organizationId]="contactsManagerTarget?.organizationId ?? null"
  [projectName]="contactsManagerTarget?.projectName ?? ''" [organizationName]="contactsManagerTarget?.organizationName ?? ''"
  [readOnly]="contactsManagerTarget?.readOnly ?? true"
  (saved)="onContactsSaved($event)"></app-project-contacts-manager>

<app-confirmation-alert [showAlert]="!!discardConfirm" [message]="discardConfirmMessage"
  (response)="onDiscardConfirm($event)"></app-confirmation-alert>

<p-dialog [visible]="!!projectTextDialog" [modal]="true" [closable]="false" [closeOnEscape]="false" [draggable]="false"
  [resizable]="false" appendTo="body" styleClass="pd-text-dialog">
  <ng-template pTemplate="header">
    <div class="pd-text-dialog-head">
      <span class="p-dialog-title">{{ projectTextDialog?.mode === 'edit' ? 'Edit ' + projectTextLabel.toLowerCase() : projectTextLabel }}</span>
      <span class="pd-hint">{{ selectedProject?.name }} · Project #{{ selectedProject?.id }}@if (projectTextDialog?.field === 'notes' && selectedProject?.updatedOn) { · Updated {{ selectedProject.updatedOn | date:'MM/dd/yyyy' }} }</span>
    </div>
    <button type="button" class="p-dialog-header-icon p-dialog-header-close p-link pd-text-close" (click)="closeProjectText()" aria-label="Close">
      <span class="pi pi-times"></span>
    </button>
  </ng-template>
  @if (projectTextDialog; as d) {
    <div class="pd-text-dialog-body" (keydown.escape)="closeProjectText()">
      @if (d.mode === 'read') {
        <div class="pd-text-full">{{ projectTextValue || ('No ' + projectTextLabel.toLowerCase()) }}</div>
      } @else {
        <textarea class="form-control pd-text-editor" [(ngModel)]="d.draft" [disabled]="d.saving" (keydown)="onProjectTextKeydown($event)"
          [attr.aria-label]="projectTextLabel" appSpellCheck cdkFocusInitial></textarea>
        @if (d.error) { <div class="pd-text-error" role="alert">{{ d.error }}</div> }
      }
    </div>
  }
  <ng-template pTemplate="footer">
    @if (projectTextDialog; as d) {
      <div class="pd-text-dialog-foot">
        @if (d.mode === 'read') {
          <button type="button" class="btn btn-light" (click)="copyToClipboard('text-' + d.field, projectTextValue)" [disabled]="!projectTextValue">
            <i class="mdi mdi-content-copy"></i> {{ copiedKey === 'text-' + d.field ? 'Copied!' : 'Copy text' }}
          </button>
          <span class="pd-text-spacer"></span>
          @if (canEditProjectText) {
            <button type="button" class="btn btn-light" (click)="editProjectText()"><i class="mdi mdi-pencil-outline"></i> Edit</button>
          }
          <button type="button" class="btn btn-primary" (click)="closeProjectText()">Close</button>
        } @else {
          <span class="pd-hint pd-text-spacer">Esc to cancel · Ctrl/⌘ + Enter to save</span>
          <button type="button" class="btn btn-light" (click)="closeProjectText()" [disabled]="d.saving">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveProjectText()" [disabled]="d.saving || !projectTextChanged">
            Save @if (d.saving) { <i class="fa fa-solid fa-sync fa-spin ms-1"></i> }
          </button>
        }
      </div>
    }
  </ng-template>
</p-dialog>
